import React, {useState} from "react";
import {readableDate} from "../../../../utils";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../../../state/selectors";
import axios from "axios";
import {createSetDataFreshAction} from "../../../../actions/dataActions";
import useSafeSave from "../../../../hooks/useSafeSave";
import useEditableTableDateCell from "../../../../hooks/useEditableTableDateCell";

function ArrivingRow({value, finance, activeTab, index, onVehicleUpdate, endpoint}) {
  const [lastEdited, setLastEdited] = useState();
  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  const [editable, setEditable] = useState(false);
  const dateFields = ["ordered_date", "delivery_date", "deposit_allocated_date"];

  const fixEmptyDates = vehicleData => {
    dateFields.forEach(function (date) {
      if (vehicleData[date] === "") {
        vehicleData[date] = null;
      }
    });
    return vehicleData;
  }

  const checkUpdated = () => {
    return axios.get(endpoint + "vehicles/" + value.id).then(newVehicle => {
      return newVehicle.data.last_saved === value.last_saved;
    });
  };

  const submitUpdate = () => {
    const url = endpoint + "vehicles/" + value.id;
    const data = fixEmptyDates(value);
    const conf = {
      method: "put",
      data,
      url
    };

    return axios(conf).then(() => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };

  const [makeDirty, safeSave] = useSafeSave(
    submitUpdate,
    lastEdited,
    undefined,
    checkUpdated
  );

  const onChange = e => {
    makeDirty();
    setLastEdited(new Date());
    let newVeh = {...value};
    newVeh[e.target.name] = e.target.value;
    onVehicleUpdate(index, newVeh);
  }

  const onOrderChange = e => {
      let newOrders = [...value.orders];
      newOrders[0][e.target.name] = e.target.value;
      const toUpdate = {
          target: {
              name: "orders",
              value: newOrders
          }
      };
      onChange(toUpdate);
  }
  return (
      <tr
          className="clickable"
          onClick={() => window.open("/editvehicle/" + value.id, "_self")}
          key={value.id}
      >
        <td data-testid={"vehicle-ordernum"}>{value.orders[0] ? value.orders[0].order_number : ""}</td>
        <td data-testid={"vehicle-registration"}>
        <span className="registration-field">
          {value.registration}
        </span>
        </td>
        {useEditableTableDateCell({
          propName: "month_due",
          value: value.orders[0] ? value.orders[0].month_due: null,
          onChange: onOrderChange,
          onSave: safeSave,
          editable,
          setEditable,
          monthOnly: true,
          inlineEdit: true
        })}
        <td data-testid={"vehicle-deposit_date"}>{value.orders[0] ? readableDate(value.orders[0].deposit_allocated_date) : ""}</td>
        <td data-testid={"vehicle-deposit"}>{value.orders[0] ? value.orders[0].deposit_to_be_paid ? "£" + value.orders[0].deposit_to_be_paid : "" : ""}</td>
        {useEditableTableDateCell({
          propName: "delivery_date",
          value: value.orders[0] ? value.orders[0].delivery_date : null,
          onChange: onOrderChange,
          onSave: safeSave,
          editable,
          setEditable,
          inlineEdit: true
        })}
        <td data-testid={"vehicle-make"}>{value.make}</td>
        <td data-testid={"vehicle-model"}>{value.model}</td>
        <td data-testid={"vehicle-variant"}>{value.variant}</td>
        <td data-testid={"vehicle-department"}>{value.department}</td>
        <td data-testid={"vehicle-vin"}>{value.vin_number}</td>
        <td data-testid={"vehicle-purchaseprice"}>{value.orders[0] ? value.orders[0].ordered_purchase_price ? "£"+value.orders[0].ordered_purchase_price : "" : ""}</td>
        <td data-testid={"vehicle-reservecustomer"}>{value.orders[0] ? value.orders[0].reserve_customer ? value.orders[0].reserve_customer.display_name : "None Set" : ""}</td>
        <td data-testid={"vehicle-comments"}>{value.orders[0] ? value.orders[0].ordering_comments : ""}</td>
      </tr>
  )
}

export default ArrivingRow;
